<p>progress-mask works!</p>
